import React, { useContext, useEffect } from 'react'
import { AppSettings } from '../../config/app-settings'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import LanguageDropdown from '../../components/LanguageDropdown'
import DomainCategoryDropdown from '../../components/DomainCategoryDropdown'
import TextArea from 'antd/es/input/TextArea'
import {  useUpdateDomainBulkMutation } from '../../redux/apis/domainsManagement/domains/dMDomainsApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import { Select } from 'antd'

const BulkDomainsUpdate = React.memo(() => {
  const [update, { isLoading, error, isSuccess }] =
    useUpdateDomainBulkMutation()
  const context = useContext(AppSettings)
  function cleanUrls (urls) {
    return urls.map(url => {
      // Remove "www.", "https://", "http://", and anything after common domain suffixes
      return url.replace(
        /^(https?:\/\/)?(www\.)?([^\/]+)(\.[a-z]{2,})(\/.*)?$/,
        '$3$4'
      )
    })
  }
  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      domains: '',
      language: '',
      domain_category: '',
      crawling_priority: 1
    },

    validationSchema: Yup.object({
      domains: Yup.string().required('Please Enter Domains'),
      language: Yup.number().required('Please Enter Domain Language'),
      domain_category: Yup.number().required('Please Enter Domain Category'),
      crawling_priority: Yup.number().required(
        'Please Enter Domain Crawl periority'
      )
    }),

    onSubmit: async values => {
      const domains = values.domains
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)
      const cleanDomains = cleanUrls(domains)

      const data = cleanDomains.map(domain => {
        return {
          domain_name: domain,
          language: values.language,
          domain_category: values.domain_category,
          crawling_priority: values.crawling_priority,
          last_updated_by_id: getUserId()
        }
      })
      try {
        const res = await update({body:data}).unwrap()
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
      if (error?.data) {
        const errorMessages = Object.values(error.data).flat()
        errorMessages.forEach(message => {
          toast.error(message)
        })
      }
    }, [error])
  
    useEffect(() => {
      if (isSuccess) {
        toast.success('Domains Updated successfully!')
      }
    }, [isSuccess])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div>
      <Loader isLoading={isLoading} />
      <Card>
        <CardHeader>Domains Bulk Update</CardHeader>
        <CardBody>
          <LanguageDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('language', e)
            }}
            value={validation.values?.language}
            className='customSelect'
          />
          {validation.touched.language && validation.errors.language ? (
            <p className='text-danger'>{validation.errors.language}</p>
          ) : null}
          <DomainCategoryDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('domain_category', e)
            }}
            value={validation.values?.domain_category}
            className='customSelect'
          />
          {validation.touched.domain_category &&
          validation.errors.domain_category ? (
            <p className='text-danger'>{validation.errors.domain_category}</p>
          ) : null}
          <div className=' mb-3 flex-1'>
            <label>Crawling Priority</label>
            <br />
            <Select
              className={'customSelect'}
              name='crawling_priority'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.crawling_priority}
              value={validation?.values?.crawling_priority}
              onChange={e => validation.setFieldValue('crawling_priority', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Low',
                  value: 1
                },
                {
                  label: 'Medium',
                  value: 2
                },
                {
                  label: 'High',
                  value: 3
                }
              ]}
            />
            {validation.touched.crawling_priority &&
            validation.errors.crawling_priority ? (
              <p className='text-danger'>
                {validation.errors.crawling_priority}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Domains</label>
            <TextArea
              type='text'
              name='domains'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.domains}
              placeholder='Enter Domain Names separated by new lines
                example: 
                test.com
                test2.com
                test3.com
                '
              rows={15}
            />
            {validation.touched.domains && validation.errors.domains ? (
              <p className='text-danger'>{validation.errors.domains}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

export default BulkDomainsUpdate
